import React, { useEffect, useState } from "react";
import { CCard, CCardBody, CCardHeader, CCol, CRow, CSpinner } from "@coreui/react";
import clientApi from "src/network";
import QuizAccordion from "src/components/question";

const TravelQuiz = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [quizItem, setQuizItem] = useState([]);

  useEffect(() => {
    TravelQuizAction();
  }, []);

  const TravelQuizAction = async () => {
    try {
      setIsLoading(true);
      const { data } = await clientApi.get("/questions", { params: { category: "travel" } });
      setQuizItem(data?.questions);
      setIsLoading(false);
    } catch (err) {
      console.log("err", err);
    }
  };
  return (
    <>
      {isLoading ? (
        <div className="text-center mt-5"><CSpinner color="primary" /></div>
      ) : (
        <CRow>
          <CCol xs={12}>
            <CCard className="mb-4">
              <CCardHeader>Travel Quiz</CCardHeader>
              <CCardBody>
                {quizItem.length > 0 && 
                <QuizAccordion quizItem={quizItem} isBadge={true} />}
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      )}
    </>
  );
};

export default TravelQuiz;
